<template>
<v-card >

<v-card-title class='overline pl-5' >
  Appointment Types ({{ filteredProducts.length }})
  <v-spacer/>
  <v-btn @click="showArchived = !showArchived" small flat >
    <v-icon v-if='!showArchived' small class='mr-2' >check_box_outline_blank</v-icon>
    <v-icon v-else small class='mr-2' >check_box</v-icon>
    Show archived
  </v-btn>
  <!-- <v-checkbox dense
    class='caption'
    label='Show archived appointment types' /> -->
</v-card-title>

<template v-if='members && members.length > 1' >
    <v-tabs >
      <v-tab
        v-for='membership in members'
        :key='membership.id'
        @click='selectedPractitionerId=membership.user' >
        {{ practitionerFullName(membership.user) }}
      </v-tab>
      <!-- {{selectedPractitioner}} -->
    </v-tabs>
  </template>
  <!-- <pre v-text='activeService' /> -->
  <request-status
    :request='servicesSaveProductRequest'
    :message200='false'
    @ok='requestOK' />

  <crud-table flat dense
    :headers='productHeaders'
    :items='filteredProducts'
    :with-expand='true'
    delete-icon='archive'
    delete-text='Archive'
    confirm-delete-title='Are you sure you want to archive this appointment type?'
    confirm-delete-tagline='We will not delete this appointment type unless it has no appointments attached to it. If it has appointments, it will be archived. So previous appointments with this appointment type will retain this information, but this appointment type will no longer be visible'
    :wait-for-server='true'
    :delete-req-id='requests.service.products'
    :create-req-id='requests.service.products'
    :edit-req-id='requests.service.products'
    :close-on-edit='false'
    :dialog-width='800'
    :with-inline-help='false'
    :loading='servicesSaveProductRequest.loading'
    @add='addProduct'
    @edit='editProduct'
    @delete='deleteProduct'
    @input='itemsChanged' >

    <v-list dense dark slot='addedit-cardtext-outer' v-if='selectedPractitioner && selectedPractitioner.id' >
      <practitioner-list-item :item='selectedPractitioner' >
      </practitioner-list-item>
      <v-divider></v-divider>
    </v-list>

    <template v-slot:duration="props" >
      {{props.value}} mins
    </template>
    <template v-slot:booking_notice_in_minutes="props" >
      <span v-if='props.value < 1440' >Same day</span>
      <span v-else-if='props.value < 2880' >Next day</span>
      <span v-else-if='props.value >= 2880' >2 day</span>
    </template>
    <template v-slot:price="props" >
      {{ formatCurrency(props.item.currency, props.value) }}
    </template>

    <template v-slot:locations="props" >
      <!-- L:{{props.value}} -->
      <template v-if='props.value && props.value.length === 0' >
        <span class='warning--text' >
        <v-icon small class='mr-1 warning--text' >warning</v-icon> Add a location
        </span>
      </template>
      <template v-else
        v-for='locId in props.value' >
      <v-chip
        v-if='$store.getters.getLocationById(locId) && $store.getters.getLocationById(locId).id'
        :id='locId' class="v-chip--x-small" label >
        <span v-text="$store.getters.getLocationById(locId).name" />
      </v-chip>
      <span v-else >{{locId}}</span>
      </template>
    </template>

    <template slot='expand' slot-scope="props" >
      <v-card full-width flat >
        <v-card-text>
          <copy-text-field
            :text-to-copy='`https://book.appt.guru/?p=${selectedPractitioner.id}&at=${props.item.id}`'
            label='Booking link'
            prepend-icon='link'
            hint='This link will take your client to a booking page with this appointment type pre-selected' >
          </copy-text-field>
        </v-card-text>
      </v-card>
    </template>
  </crud-table>
</v-card>
</template>
<script>
import CrudTable from '@/components/CrudTable.vue'
import PractitionerListItem from '@/components/listitems/PractitionerListItem.vue'
import BackgroundSelector from '@/components/ui/BackgroundSelector.vue'
import TextEditor from '@/components/ui/TextEditor.vue'
import CopyTextField from '@/components/ui/CopyTextField.vue'
import LocationPicker from '@/components/pickers/LocationPicker.vue'

const ProductFields = [
  'title',
  'is_online',
  'duration',
  'price',
  'order',
  'booking_notice_in_minutes',
  'background_picture',
  'description',
  'notes',
  'private',
  'comes_to_you',
  'locations'
]

export default {
  name: 'ProductEdit',
  components: { CrudTable, PractitionerListItem, CopyTextField },
  props: {
    value: { type: Object, required: true }
  },
  data () {
    return {
      showArchived: false,
      selectedPractitionerId: null,
      requestAction: 'saved',
      requests: {
        service: {
          products: 'products-update-save-request'
        }
      }
    }
  },
  mounted () {
    if (!this.selectedPractitionerId) {
      this.selectedPractitionerId = this.meId
    }
  },
  methods: {
    extractFields (fields, data) {
      let payload = {}
      fields.forEach((field) => {
        payload[field] = data[field]
      })
      if (!payload.background_picture || payload.background_picture === '' || payload.background_picture === '{}') {
        delete payload.background_picture
      }
      return payload
    },
    practitionerFullName (practitionerId) {
      let practitioner = this.$store.getters.getPractitionerById(practitionerId)
      if (practitioner) {
        return practitioner.full_name
      }
      return practitionerId
    },
    addProduct (data) {
      this.requestAction = 'added'
      let payload = this.extractFields(ProductFields, data)
      payload.service = this.serviceId
      payload.practitioner = this.selectedPractitionerId
      if (payload.locations === '') { payload.locations = [] }

      if (!Array.isArray(payload.locations)) {
        payload.locations = [payload.locations]
      }
      if (payload.is_online === '') { payload.is_online = false }
      if (payload.private === '') { payload.private = false }
      if (payload.comes_to_you === '') { payload.comes_to_you = false }
      if (payload.background_picture === '' || payload.background_picture === '{}') {
        delete payload.background_picture
      }
      payload = JSON.stringify(payload)
      this.$appointmentguru
        .resource('practitioner.services.products')
        .id(this.requests.service.products)
        .create(payload)
    },
    editProduct (data) {
      this.requestAction = 'saved'
      let payload = this.extractFields(ProductFields, data)
      this.$appointmentguru
        .resource('practitioner.services.products')
        .id(this.requests.service.products)
        .save(data.id, JSON.stringify(payload))
    },
    deleteProduct (data) {
      this.requestAction = 'deleted'
      // window.alert('To delete appointment types please contact support, or click "Do it for me" in the menu. Please quote delete appointment type #' + data.id + ' for me')
      this.$appointmentguru.resource('practitioner.services.products').id(this.requests.service.products).delete(data.id)
    },
    requestOK (result) {
      this.$emit(this.requestAction, result)
    },
    itemsChanged (items) {
      this.products = items
    }
  },
  computed: {
    service () { return this.value },
    serviceId () { return this.getObjectPath(this.service, 'id') },
    members () { return this.getObjectPath(this.service, 'practitioners', []) },
    filteredProducts () {
      // console.log(service.products.length)
      if (this.service && this.service.products) {
        return this.service.products.filter((p) => {
          if (!this.showArchived && p.archived) { return false }
          return (p.practitioner === this.selectedPractitionerId)
        })
      }
      return []
    },
    selectedPractitioner () {
      return this.$store.getters.getPractitionerById(this.selectedPractitionerId)
    },
    servicesSaveProductRequest () {
      return this.$store.getters.getRequestById(this.requests.service.products, true)
    },
    servicesSaveRequestStatus () {
      return this.servicesSaveRequest.status
    },
    productHeaders () {
      let currency = this.defaultCurrency
      return [
        // { text: 'ID', value: 'id' },
        {
          text: 'Background',
          value: 'background_picture',
          component: BackgroundSelector,
          displayInTable: false,
          flex: {xs12: true, sm12: true}
        },
        { text: 'Name', value: 'title', hint: 'e.g.: Initial consultation, follow-up consultation, 45 minute therapy session' },
        {
          text: 'Duration',
          value: 'duration',
          flex: {xs12: true, sm6: true},
          hint: 'How long is this appointment type (in minutes)',
          suffix: 'mins',
          type: 'number'
        },
        {
          text: 'Price',
          value: 'price',
          prefix: currency,
          type: 'number',
          flex: {xs12: true, sm6: true},
          hint: 'This is the default price for this appointment and will be set when the appointment is created. You can change the price later, and it will be adjusted automatically if you add ICD10 codes'
        },
        // { text: 'Private', value: 'private' },
        {
          text: 'Order',
          value: 'order',
          type: 'number',
          flex: {xs12: true, sm6: true},
          displayInTable: false,
          hint: 'The order in which this should appear on your website and booking forms'
        },
        {
          text: 'Booking notice',
          value: 'booking_notice_in_minutes',
          component: 'vselect',
          attrs: {
            items: [
              { text: 'Same day', value: 0 },
              { text: 'Next day', value: 1440 },
              { text: '2 day', value: 2880 }
            ]
          },
          hint: 'How much notice do you require for bookings placed online',
          flex: {xs12: true, sm6: true}
        },
        {
          text: 'Locations',
          value: 'locations',
          component: LocationPicker,
          attrs: {
            spaceId: this.serviceId,
            hint: 'At which locations is this appointment type available?',
            required: true
          }
        },
        { component: 'vdivider', value: 'div-after-locations' },
        // { text: 'Currency', value: 'currency', default: 'ZAR' },
        {
          text: 'Description',
          value: 'description',
          type: 'text',
          flex: {xs12: true, sm6: true},
          attrs: {
            label: 'Description',
            initialAttrs: {
              hint: 'The description will show on your booking page. You can also use it in your notificiations: <code>{appointment.product.description}</code>'
            }
          },
          component: TextEditor,
          displayInTable: false
        },
        {
          text: 'Notes',
          value: 'notes',
          type: 'text',
          component: TextEditor,
          attrs: {
            label: 'Notes',
            initialAttrs: {
              hint: 'Use notes to provide extra information about this appintment. e.g.: What to wear, what to expect, how to prepare. Ideal for adding extra information to your notifications <code>{appointment.product.notes}</code>'
            }
          },
          flex: {xs12: true, sm6: true},
          displayInTable: false
        },
        {
          text: 'Online',
          value: 'is_online',
          type: 'boolean',
          flex: {xs12: true, sm6: true},
          component: 'vcheckbox',
          hint: 'Check this if this is a virtual appointment that occurs online (e.g.: with Zoom)'
        },
        {
          text: 'Flexible location',
          flex: {xs12: true, sm6: true},
          value: 'comes_to_you',
          type: 'boolean',
          component: 'vcheckbox',
          hint: 'Check this if the location for this appontment can vary. For example: a house call or a meeting in a coffee shop'
        },
        {
          text: 'Private',
          value: 'private',
          type: 'boolean',
          component: 'vcheckbox',
          hint: 'Private appointments do not show up on your website or booking page, but you can send a direct booking link to a customer'
        }
        // { text: 'Archived', value: 'archived' }
      ]
    }
  }
}
</script>



// WEBPACK FOOTER //
// ProductEdit.vue?464cc587